import React, { useId } from 'react';


/**
 * Small green-checkmark glyph used as the "this guest is matched"
 * indicator (matching lodging / matching amenity) on the river,
 * tradelanes, deck-bar grid, and player orbits. Sizing and positioning
 * come from the className the caller passes in (e.g.
 * `orbit-card-matching-lodging` / `tradelane-matching-lodging` /
 * `deck-grid-card-matching-left`); this component only renders the
 * glyph.
 *
 * The radial gradient id is per-instance via `useId` so multiple
 * <CheckmarkIcon/> in the same document never collide on `<defs>` ids.
 *
 * Pattern mirrors FireIcon (used for the burn indicator) so the two
 * indicator families read as a matched set.
 */
export default function CheckmarkIcon({ className, style, title }) {
    const gradientId = useId();
    return (
        <svg className={className}
             style={style}
             viewBox="0 0 20 20"
             xmlns="http://www.w3.org/2000/svg"
             role={title ? 'img' : 'presentation'}
             aria-hidden={title ? undefined : true}>
            {title && <title>{title}</title>}
            <defs>
                <radialGradient id={gradientId} cx="50%" cy="35%" r="70%">
                    <stop offset="0%" stopColor="#a8f59a"/>
                    <stop offset="60%" stopColor="#2ecc40"/>
                    <stop offset="100%" stopColor="#0e5a17"/>
                </radialGradient>
            </defs>
            <circle
                cx="10"
                cy="10"
                r="8.4"
                fill={`url(#${gradientId})`}
                stroke="#0a3d10"
                strokeWidth="0.9"
            />
            <path
                d="M5.8 10.6 L8.8 13.6 L14.4 7.4"
                fill="none"
                stroke="#ffffff"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
